import axios from 'axios'

function Post(url,data,callback,header){
    axios.post(url,data,header).then(function (response) {
        callback(response);
    }).catch(function(err){
        console.log(err);
    })
}

export default  Post;



// WEBPACK FOOTER //
// ./src/api/post.js